import { datadogRum } from '@datadog/browser-rum'

import { CONFIG } from '../config'

export const initDatadogRUM = (appVersion) => {
  const hn = window.location.hostname
  let env = null

  // Dynamically set DD env based on hostname.
  // Cannot use an env var during build time because
  // we need to distinguish between sit, opt and prod.
  if (hn === 'smarty.co.uk') {
    env = 'production'
  } else if (hn.startsWith('sit.')) {
    env = 'sit'
  } else if (hn.startsWith('sandbox.')) {
    env = 'sandbox'
  } else if (hn.startsWith('opt.')) {
    env = 'opt'
  } else if (hn.startsWith('dev.')) {
    env = 'dev'
  }

  // If no env is set - do NOT use RUM
  if (!env) return

  // If keys not present - do NOT use RUM.
  if (!CONFIG.DATADOG_APP_ID || !CONFIG.DATADOG_TOKEN) return

  // It is safe to call this method multiple times - Datadog takes care of it
  // and only initialises the RUM collector once (thanks to silentMultipleInit flag)
  datadogRum.init({
    applicationId: CONFIG.DATADOG_APP_ID,
    clientToken: CONFIG.DATADOG_TOKEN,
    site: CONFIG.DATADOG_HOST,
    service: CONFIG.DATADOG_SERVICE_NAME,
    env,
    version: appVersion,
    sampleRate: 100,
    trackInteractions: true,
    silentMultipleInit: true,
    trackSessionAcrossSubdomains: true,
    allowedTracingOrigins: [
      'https://smarty.co.uk',
      'https://www.smarty.co.uk',
      /https:\/\/.*\.smarty\.3\.uk/,
    ],
  })
}

export const logErrorAndNotify = (error, context = {}) => {
  console.error(error)
  datadogRum.addError(error, context)
}
